import { usePrivileges } from '@/hooks/usePrivilleges';
import { Instability } from '@/Pages/Instability/Instability';
import { Maintenance } from '@/Pages/Maintenance/Maintenance';

export const useShowFallbackPage = () => {
  const {
    pages: { fallback },
  } = usePrivileges();

  const showPage = () => {
    switch (true) {
      case fallback.showMaintenanceMode:
        return <Maintenance />;
      case fallback.showInstabilityMode:
        return <Instability />;
      default:
        return null;
    }
  };

  return {
    showPage,
  };
};
